import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  constructor(
    protected readonly http: HttpClient
  ) {}

  getOfURL(url, options?): Observable<any> {
    return this.http.get(`${url}`, options).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          return throwError(err.error || err);
        }
        return throwError(err);
      })
    );
  }

  getAll(url): Observable<any[]> {
    return this.http.get<any[]>(url).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          return throwError(err.error || err);
        }
        return throwError(err);
      })
    );
  }

  get(url, id): Observable<any> {
    return this.http.get<any>(`${url}/${id}`).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          return throwError(err.error || err);
        }
        return throwError(err);
      })
    );
  }

  getWhitoutId(url): Observable<any> {
    return this.http.get<any>(`${url}`).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          return throwError(err.error || err);
        }
        return throwError(err);
      })
    );
  }

  protected addOfURL(url, model: any, httpOptions?: any): Observable<any> {
    return this.http.post<any>(`${url}`, model, httpOptions).pipe(
      catchError(err => {
         return throwError(err);
      })
    );
  }

  protected updateOfURL(url, model: any): Observable<any> {
    return this.http.patch(`${url}`, model);
  }

  protected deleteOfURL(url, model: any): Observable<any> {
    return this.http.delete<any>(`${url}`);
  }

  // File Service

  getFileOfURL(url, options?): Observable<any> {
    if (options) {
      options.responseType = 'blob' as 'json';
      options.observe = 'response' as 'body';
    } else {
      options = {
        responseType : 'blob' as 'json',
        observe: 'response' as 'body'};
    }
    return this.http.get(url, options)
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  getDocumentConfig(url, options?): Observable<any> {
    if (options) {
      options.responseType = 'blob' as 'json';
      options.observe = 'response' as 'body';
    } else {
      options = {
        responseType: 'blob' as 'json',
        observe: 'response' as 'body'
      };
    }
    return this.http.get(url, options)
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  getHtmlReportOfURL(url, options): Observable<any> {
    options.responseType = 'text';
    options.observe = 'response';
    return this.http.get(url, options)
    .pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  getXlsxReportOfURL(url, options): Observable<any> {
    if (!options) {
      options = {};
    }
    options.responseType = 'blob';
    options.observe = 'response';
    return this.http.get(url, options)
    .pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  getFileOfURLWithReportName(url, fileName, options?): Observable<any> {
    if (options) {
      options.responseType = 'blob' as 'json';
      options.observe = 'response' as 'body';
    } else {
      options = {
        responseType : 'blob' as 'json',
        observe: 'response' as 'body'};
    }
    const _url = fileName && fileName !== null ? `${url}/${fileName}` : `${url}`;
    return this.http.get(_url, options)
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  getUsingPost(url, options): Observable<any> {
    return this.http.post(`${url}/`, options).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

}
